import loadable from "@loadable/component";
import AEMWrapper from "aem/ComponentWrapper";
import React from "react";
import meta from "./aem-meta";

const Component = loadable(
  () => import(/* webpackChunkName: "component-static-json-provider" */ "."),
  {
    fallback: <></>
  }
);

export default AEMWrapper(meta, Component);
